interface StorageItem<T> {
  value: T;
  expiry: number;
}

/**
 * Get item from storage with expiry check
 */
export const getWithExpiry = <T>(key: string): T | null => {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item: StorageItem<T> = JSON.parse(itemStr);
    const now = new Date().getTime();

    if (now > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (error) {
    console.error("Error getting item from storage:", error);
    return null;
  }
};

/**
 * Set item in storage with expiry
 */
export const setWithExpiry = <T>(key: string, value: T, ttlMs: number): void => {
  try {
    const now = new Date().getTime();
    const item: StorageItem<T> = {
      value,
      expiry: now + ttlMs,
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.error("Error setting item in storage:", error);
  }
};

/**
 * Remove item from storage
 */
export const removeFromStorage = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing item from storage:", error);
  }
}; 